import http from '../http'
import { Res } from '../type'
import { ArticleDetail, CommentPraiseRes, LikeInfo } from '../Models/MessageIndexList'
import {
  ArticleCategorysList,
  ArticleDetailParams,
  LikeSendParams,
  LikeCancelParams,
  LikeInfoParams,
  InfoAndClassParams,
  InfoAndClassRes,
  ArticleCategorysParams
} from '../Models/ArticleCategorys'
import { CommentList, CommentListParams, CommentReplyParams } from '../Models/CommentList'
import { ArticleList, ArticleListParams, AddViewCountInterfaceData } from '../Models/ArticleList'
import { CommentCreateParams } from '../Models/CommentCreate'

// 行业动态相关接口

// // 企业资讯文章分类-C端-查询文章分类
// export const getArticleCategorys = (): Res<ArticleCategorysList[]> => {
//   return http.request({
//     url: '/sands-lms/api/v1/articleCategory/articleList',
//     method: 'GET'
//   })
// }

// 2.3.2 需求改版
// 企业资讯文章分类-C端-查询文章分类副本
export const getArticleCategorys = (params: ArticleCategorysParams): Res<ArticleCategorysList[]> => {
  return http.request({
    url: '/sands-lms/api/v1/articleCategory/listThreeLevelByIds',
    method: 'POST',
    data: params,
    loadingShow: '0'
  })
}

// 企业资讯文章-C端-根据类别查询文章(分页)
export const getArticleList = (params: ArticleListParams): Res<ArticleList> => {
  return http.request({
    url: '/sands-lms/api/v1/article/page',
    method: 'post',
    data: params,
    loadingShow: params.loadingShow as '0' | '1' | undefined
  })
}

// 获取详情页信息
export const apiGetDetailInfo = (params: ArticleDetailParams): Res<ArticleDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/article/get',
    method: 'GET',
    params,
    toastShow: '0'
  })
}

// 根据模块获取点赞信息
export const getLikeInfo = (params: LikeInfoParams): Res<LikeInfo> => {
  return http.request({
    url: '/sands-lms/api/v1/like/get',
    method: 'GET',
    params
  })
}

// 资讯---获取评论数据
export const apiGetCommentList = (params: CommentListParams): Res<CommentList> => {
  return http.request({
    url: '/sands-lms/api/v1/comment/page',
    method: 'POST',
    data: params,
    loadingShow: params.loadingShow as '0' | '1' | undefined
  })
}

// 创建评论
export const apiPublishComment = (params: CommentCreateParams): Res<{ reviewStatus?: number }> => {
  return http.request({
    url: '/sands-lms/api/v1/comment/create',
    method: 'POST',
    data: params,
    loadingShow: params.loadingShow as '0' | '1' | undefined
  })
}

// 资讯详情-模块点赞
export const postLikeSend = (params: LikeSendParams): Res<CommentPraiseRes> => {
  return http.request({
    url: '/sands-lms/api/v1/like/likeOption',
    method: 'POST',
    data: params,
    loadingShow: '0'
  })
}

// 资讯详情-模块取消点赞
export const postLikeCancel = (params: LikeCancelParams): Res<CommentPraiseRes> => {
  return http.request({
    url: '/sands-lms/api/v1/like/cancelLike',
    method: 'POST',
    data: params,
    loadingShow: '0'
  })
}

export const infoAndClass = (params: InfoAndClassParams): Res<InfoAndClassRes> => {
  return http.request({
    url: '/sands-lms/api/v1/homePageDecorate/infoAndClass',
    method: 'POST',
    data: params
  })
}

// C端-文章增加浏览量(文章类型为链接)
export const addViewCountReq = (params: ArticleDetailParams): Res<AddViewCountInterfaceData> => {
  return http.request({
    url: '/sands-lms/api/v1/article/addViewCount',
    method: 'GET',
    params
  })
}

// C端-文章增加浏览量(文章类型为链接)
export const addUvCountReq = (params: ArticleDetailParams): Res<AddViewCountInterfaceData> => {
  return http.request({
    url: '/sands-lms/api/v1/article/addUv',
    method: 'GET',
    params
  })
}

// 资讯---获取评论数据
export const apiGetCommentReplyNum = (params: CommentReplyParams): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/comment/count',
    method: 'GET',
    params,
    loadingShow: params.loadingShow as '0' | '1' | undefined
  })
}

// 保存文章学习时长
export const apiSaveArticleLearnTime = (params: ArticleDetailParams): Res<{ dailyLearningDurationLimit: number }> => {
  return http.request({
    url: '/sands-lms/api/v1/article/saveArticleLearnTime',
    method: 'GET',
    params,
    loadingShow: '0'
  })
}
